<template>
  <div id="loginbackground">
    <div class="loginCont">
      <div id="loginText">
        <p>猎户语音OS 真开放</p>
        <ul>
          <li>
            <span class="logSpan"></span>
            <span>全链路自研</span>
          </li>
          <li>
            <span class="logSpan"></span>
            <span>行业一流人机交互体验</span>
          </li>
          <li>
            <span class="logSpan"></span>
            <span>数据，商业，内容，技能全开放</span>
          </li>
          <li>
            <span class="logSpan"></span>
            <span>简单高效地接入AI能力</span>
          </li>
        </ul>
      </div>
  <div class="forgetPassword">
    <p>修改密码</p>
    <div class="main_container">
      <el-form :rules="registerInspect" :model="registerInfo" ref="userInfo">
        <el-form-item prop="user_phone">
          <el-input placeholder="请输入您的手机号" v-model.trim="registerInfo.user_phone"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="verification">
          <el-input placeholder="请输入四位验证码" v-model="registerInfo.code"></el-input>
          <el-button round @click="getRegister">{{time}}</el-button>
        </el-form-item>
        <el-form-item prop="new_password">
          <el-input type="password" placeholder="请输入您新的密码" v-model="registerInfo.new_password"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" placeholder="请二次确认您的密码" v-model="registerInfo.password"></el-input>
        </el-form-item>

      </el-form>
    </div>
    <el-button type="primary" round @click="checkPassword"
               :disabled="!registerInfo.user_phone || !registerInfo.password || !registerInfo.code">确定
    </el-button>
    <!--<router-link to="/login" class="edit_password_login">直接登陆</router-link>-->
  </div>
    </div>
  </div>
</template>
<script>
  import {login, editPassword, codeNum} from '@/api'
  import qs from 'qs'

  export default {
    created() {
    },
    data() {
      let validate_phone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入您的手机号'));
        } else {
            if (this.registerInfo.user_phone !== '') {
                let reg = /^1\d{10}$/
                let reg_tw = /^09\d{8}$/
                if (!reg.test(this.registerInfo.user_phone)) {
                    if (!reg_tw.test(this.registerInfo.user_phone)) {
                        callback(new Error('请输入正确的手机号'))
                    } else {
                        callback()
                    }
                    callback(new Error('请输入正确的手机号'))
                }
            }
            callback();
        }
      }
      let validate_pass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请二次确认您的密码'))
        } else if (value.length < 6) {
          callback(new Error('密码不能小于六位'))
        } else if (value.length > 16) {
          callback(new Error('密码不能大于十六位'))
        } else {
          if (this.registerInfo.password !== '') {
            let reg = /\s+/g
            if(reg.test(this.registerInfo.password))
            {
              callback(new Error('请输入正确的密码，不支持空格'))
            }
          }
          callback();
        }
      }
      let validate_new_pass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入您的密码'))
        } else if (value.length < 6) {
          callback(new Error('密码不能小于六位'))
        } else if (value.length > 16) {
          callback(new Error('密码不能大于十六位'))
        } else {
          if (this.registerInfo.new_password !== '') {
            let reg = /\s+/g
            if(reg.test(this.registerInfo.new_password))
            {
              callback(new Error('请输入正确的密码，不支持空格'))
            }
          }
          callback();
        }
      }
      let validate_code = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'))
        } else if (value.length != 4) {
          callback(new Error('请输入四位数字验证码'))
        }  else {
          if (this.registerInfo.code !== '') {
            let reg = /\d{4}/g
            if(!reg.test(this.registerInfo.code))
            {
              callback(new Error('请输入四位数字验证码'))
            }
          }
          callback();
        }
      }
      return {
        registerInfo: {
          user_phone: '',
          password: '',
          new_password: '',
          code: '',
        },
        registerInspect: {
          user_phone: [
            {validator: validate_phone, required: true, trigger: 'blur'},
//            {required: true, message: '请输入手机号', trigger: ['blur', 'change']},
          ],
          code: [
            {validator: validate_code, required: true, trigger: 'blur'}
//            {required: true, message: '请输入验证码', trigger: ['blur', 'change']},
          ],
          password: [
            {validator: validate_pass, required: true, trigger: 'blur'},
//            {required: true, message: '请输入密码', trigger: ['blur', 'change']},
          ],
          new_password: [
            {validator: validate_new_pass, required: true, trigger: 'blur'},
//            {required: true, message: '请输入密码', trigger: ['blur', 'change']},
          ]
        },
        time: '获取验证码'
      }
    },
    methods: {
      async getRegister() {
        let re = /^1\d{10}$/
          let reg_tw = /^09\d{8}$/
          if (re.test(this.registerInfo.user_phone) || reg_tw.test(this.registerInfo.user_phone)) {

          } else {
              this.$message({message: '手机号格式错误', type: 'error', duration: 1000});
              return
          }
        if (this.time != '获取验证码') {
          this.$message.error('60s内无法再次获取验证码')
          return
        }
        let res = await codeNum(qs.stringify({'user_phone': this.registerInfo.user_phone}))
        if (res.data.code == 200) {
          let date = 60
          let Time = setInterval(() => {
            date -= 1
            this.time = date + 's'
            if (date <= 0) {
              this.time = '获取验证码'
              clearInterval(Time)
            }
          }, 1000)
        } else {
          if (res.data.errors.length == 0) {
            this.$message.error('请在60S之后再来尝试一下')
          } else {
            this.$message({message: res.data.errors.phone, type: 'error'});
          }

        }
      },
      async checkPassword() {
        let re = /^1\d{10}$/
          let reg_tw = /^09\d{8}$/
          if (re.test(this.registerInfo.user_phone) || reg_tw.test(this.registerInfo.user_phone)) {

          } else {
              this.$message({message: '手机号格式错误', type: 'error', duration: 1000});
              return
          }
        if (this.registerInfo.password.length < 6 || this.registerInfo.new_password.length < 6) {
          this.$message({message: '密码不能小于6位', type: 'error'})
          return
        }
        if (this.registerInfo.password.length > 16 || this.registerInfo.new_password.length > 16) {
          this.$message({message: '密码不能超过16位', type: 'error'})
          return
        }
        if (this.registerInfo.code == '') {
          this.$message({message: '验证码不能为空', type: 'error'})
          return
        }
        if (this.registerInfo.password != this.registerInfo.new_password) {
          this.$message({message: '新密码与确认密码不一致', type: 'error'})
          return
        }
        let res = await editPassword(qs.stringify(this.registerInfo))
        if (res.data.code == 200) {
          this.$message({message: '设置密码成功', type: 'success'})
          this.$router.push('/homePage')
        } else if (res.data.code == 2501) {
          this.$message({message: '验证码输入有误，请重新输入', type: 'error'})
        } else {
//          console.log(res.data.errors);
          if (res.data.errors.data) {
            this.$message({message: res.data.errors.data, type: 'error'})
          } else {
            this.$message({message: '设置密码失败', type: 'error'})
          }
        }

      }
    },
    mounted() {
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #loginbackground {
    width: 100%;
    height: 100%;
    background: url('../../../static/images/loginBackground/login-bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
  }

  .loginCont {
    width: 937px;
    height: 380px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    #loginText {
      color: #fff;
      width: 279px;
      float: left;
      margin-top: 80px;
      p {
        font-size: 28px;
        line-height: 60px;
      }
      ul > li {
        list-style: none;
        line-height: 30px;
        span {
          font-size: 14px;
          &.logSpan {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #077eec;
            margin-right: 10px;
            vertical-align: middle;
          }
        }
      }

    }
    .forgetPassword {
      width: 370px;
      height: 480px;
      background: #fff;
      text-align: center;
      color: #4f4f4f;
      margin-top:-20px;
      float:right;
      .el-form-item .el-form-item__error{
        left:60px;
      }
      p {
        height: 64px;
        line-height: 64px;
        border-bottom: 1px solid #f5f5f5;
        font-size: 18px;
        color: #22608c;
        text-align: center;
        /*padding-left: 90px;*/
      }
      .main_container {
        text-align: center;
        padding-top: 40px;
        color: #959595;
        .el-input__inner {
          width: 260px;
          border-radius: 20px;
        }
        .el-checkbox {
          margin-left: 60px;
          .el-checkbox__input {
            margin-top: -10px;
          }
        }
        .verification .el-button {
          width: 85px;
          margin: 0;
          padding-left: 5px;
          font-size: 14px;
          height:38px;
          border: 1px solid #0091ed;
          color: #0091ed;
        }
        .verification .el-input {
          position: relative;
          left: -8px;
          width: 160px;
        }
        .verification .el-input__inner {
          width: 160px;
        }
        .agreement {
          display: inline-block;
          width: 200px;
          font-size: 12px;
          color: #7d7e7e;
          vertical-align: middle;
          span {
            color: #30a2f4;
          }
        }

      }
      .el-button {
        width: 260px;
        margin: 20px auto 0;
        font-size: 16px;
      }
      .edit_password_login {
        display: block;
        padding: 10px 20px 10px 0;
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/EditPassword.vue